import { render, staticRenderFns } from "./UcInvoiceGenerationControlling.yaml?vue&type=template&id=21e2865e&component"
import script from "./UcInvoiceGenerationControlling.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceGenerationControlling.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports